import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Formulator from './Formulator';
import FormulaLibrary from './FormulaLibrary';
import Login from './Login';
import { auth } from './firebase';
import { useAuthState } from 'react-firebase-hooks/auth';

function ProtectedRoute({ children }) {
  const [user, loading] = useAuthState(auth);
  if (loading) return <div>Loading...</div>;
  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute><FormulaLibrary /></ProtectedRoute>} />
        <Route path="/formulator" element={<ProtectedRoute><Formulator /></ProtectedRoute>} />
      </Routes>
    </Router>
  );
}

export default App;